import styled from 'styled-components'
import { Card } from 'antd'


export const StyledCard = styled(Card)`
  .text {
    margin: 50px 0;
    font-size: 20px;
    padding: 0px 25%;
  }
`



// WEBPACK FOOTER //
// ./src/components/open-posts/style.js